import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledButton } from '../ImageViewer.style';

type ZoomProps = {
  onChange: (data: any) => void;
};

export const Zoom: React.FunctionComponent<ZoomProps> = ({ onChange }) => {
  const { t } = useTranslation();
  const handleClick = useCallback(
    ({ currentTarget: { value } }) => {
      onChange({ [value]: true });
    },
    [onChange]
  );

  return (
    <>
      <StyledButton
        data-testid="image-controls-zoom-in"
        title={t('components.zoomIn', 'Zoom In')}
        value="zoomIn"
        onClick={handleClick}
      >
        <ZoomInOutlined />
      </StyledButton>
      <StyledButton
        data-testid="image-controls-zoom-out"
        title={t('components.zoomOut', 'Zoom Out')}
        value="zoomOut"
        onClick={handleClick}
      >
        <ZoomOutOutlined />
      </StyledButton>
    </>
  );
};
